import React, { useEffect } from 'react';
import { useUIControlsStore } from '../../redux';
import ThankYouBodyContent from './components/thank-you-body-content';
import TopNavbarHeader from './components/top-navbar-header';

const BSThankYou = () => {
  // FIXME: DEV Mode only, This is a temporary fix to hide the session expired modal
  const { updateShowSessionExpiredModal } = useUIControlsStore();
  useEffect(() => {
    updateShowSessionExpiredModal(false);
  }, []);

  return (
    <div className="flex flex-col bg-[#F7F5F0]">
      <TopNavbarHeader />
      <ThankYouBodyContent
        title="Thank you!"
        subtitle={`
            • Your customer's application is under review!
            <br />
            • 
            Please ask customer to upload KYC documents and set up SR to disburse loan.
            <br />• Please check the suspended tab for suspended applications
          `}
      />
    </div>
  );
};

export default BSThankYou;
